export var ZIndex;
(function (ZIndex) {
    ZIndex[ZIndex["ConsumerExploreUnavailableOverlay"] = 3] = "ConsumerExploreUnavailableOverlay";
    ZIndex[ZIndex["ConsumerExploreShefImg"] = 4] = "ConsumerExploreShefImg";
    ZIndex[ZIndex["Badge"] = 5] = "Badge";
    ZIndex[ZIndex["ConsumerExploreAppUpsellBanner"] = 7] = "ConsumerExploreAppUpsellBanner";
    ZIndex[ZIndex["SegmentFiltersContainer"] = 10] = "SegmentFiltersContainer";
    ZIndex[ZIndex["ShareDialog"] = 10] = "ShareDialog";
    ZIndex[ZIndex["OrderProgessNumberCircle"] = 11] = "OrderProgessNumberCircle";
    ZIndex[ZIndex["DropdownFilter"] = 12] = "DropdownFilter";
    ZIndex[ZIndex["HorizontalSnapBadgeContainerFadeBarOverlay"] = 13] = "HorizontalSnapBadgeContainerFadeBarOverlay";
    ZIndex[ZIndex["HorizontalSnapBadgeContainerButton"] = 14] = "HorizontalSnapBadgeContainerButton";
    ZIndex[ZIndex["OrderHistoryTabbedNavigator"] = 900] = "OrderHistoryTabbedNavigator";
    ZIndex[ZIndex["ConsumerNavBarBackdrop"] = 990] = "ConsumerNavBarBackdrop";
    ZIndex[ZIndex["ConsumerNavBar"] = 1000] = "ConsumerNavBar";
    ZIndex[ZIndex["SlideOutCart"] = 1001] = "SlideOutCart";
    ZIndex[ZIndex["ShefInfoContainer"] = 11] = "ShefInfoContainer";
    ZIndex[ZIndex["StripePaymentRequestGoogleApplePayButton"] = 1500] = "StripePaymentRequestGoogleApplePayButton";
    ZIndex[ZIndex["ShefDashboardApplicationTracker"] = 4998] = "ShefDashboardApplicationTracker";
    ZIndex[ZIndex["ShefDashboardNavBarBackdrop"] = 4999] = "ShefDashboardNavBarBackdrop";
    ZIndex[ZIndex["ShefDashboardNavBar"] = 5000] = "ShefDashboardNavBar";
    ZIndex[ZIndex["HelpButton"] = 9916] = "HelpButton";
    ZIndex[ZIndex["DeliveryDayPopover"] = 9916] = "DeliveryDayPopover";
    ZIndex[ZIndex["StickyFooter"] = 9917] = "StickyFooter";
    ZIndex[ZIndex["WaitlistQueueButtons"] = 9918] = "WaitlistQueueButtons";
    ZIndex[ZIndex["Modal"] = 10000] = "Modal";
    ZIndex[ZIndex["ModalContent"] = 10001] = "ModalContent";
    ZIndex[ZIndex["fixedloading"] = 10000] = "fixedloading";
    ZIndex[ZIndex["LightBoxBackdrop"] = 30000] = "LightBoxBackdrop";
    ZIndex[ZIndex["LightBox"] = 30002] = "LightBox";
    ZIndex[ZIndex["LightBoxMenu"] = 30004] = "LightBoxMenu";
    ZIndex[ZIndex["OffCanvasBackdrop"] = 35000] = "OffCanvasBackdrop";
    ZIndex[ZIndex["OffCanvas"] = 35001] = "OffCanvas";
    ZIndex[ZIndex["DropdownMenu"] = 40000] = "DropdownMenu";
    ZIndex[ZIndex["Tooltip"] = 50000] = "Tooltip";
})(ZIndex || (ZIndex = {}));
//# sourceMappingURL=zIndex.js.map